import React, { useState } from 'react'
import FalabellaProductsTable from '../components/tables/FalabellaProductsTable'
import { FalabellaProduct } from '../types/falabella'
//import toast from 'react-hot-toast'

const FalabellaIntegration: React.FC = () => {
  const [selectedProduct, setSelectedProduct] = useState<FalabellaProduct | null>(null)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isRefreshing, setIsRefreshing] = useState(false) // Reservado para uso futuro

  // Función comentada - no se usa actualmente
  // const handleRefreshProducts = async () => {
  //   try {
  //     setIsRefreshing(true)
  //     // Simplemente recargamos la página para obtener productos frescos
  //     window.location.reload()
  //   } catch (error: any) {
  //     console.error('Error refreshing products:', error)
  //     toast.error('Error actualizando productos de Falabella')
  //   } finally {
  //     setIsRefreshing(false)
  //   }
  // }

  // Manejar selección de producto
  const handleProductSelect = (product: FalabellaProduct) => {
    setSelectedProduct(product)
  }

  // Cerrar modal de producto
  const closeProductModal = () => {
    setSelectedProduct(null)
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className=" max-w-auto mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-4">
          <div className="flex items-center justify-between">
          </div>
        </div>


        {/* Tabla de Productos */}
        <div className="bg-white rounded-lg">
          <FalabellaProductsTable onProductSelect={handleProductSelect} />
        </div>

        {/* Modal de Detalles del Producto */}
        {selectedProduct && (
          <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
            <div className="relative top-20 mx-auto p-5 border w-11/12 md:w-3/4 lg:w-1/2 shadow-lg rounded-md bg-white">
              <div className="mt-3">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-medium text-gray-900">Detalles del Producto</h3>
                  <button
                    onClick={closeProductModal}
                    className="text-gray-400 hover:text-gray-600"
                  >
                    <span className="sr-only">Cerrar</span>
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
                
                <div className="space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700">SKU SGL</label>
                      <p className="mt-1 text-sm text-gray-900">{selectedProduct.SellerSku}</p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">SKU FL</label>
                      <p className="mt-1 text-sm text-gray-900">{selectedProduct.ShopSku}</p>
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Nombre</label>
                    <p className="mt-1 text-sm text-gray-900">{selectedProduct.Name}</p>
                  </div>
                  
                  {selectedProduct.Variation && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700">Variación</label>
                      <p className="mt-1 text-sm text-gray-900">{selectedProduct.Variation}</p>
                    </div>
                  )}
                  
                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700">Estado</label>
                      <p className="mt-1 text-sm text-gray-900">{selectedProduct.BusinessUnits.BusinessUnit.Status}</p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">QC Status</label>
                      <p className="mt-1 text-sm text-gray-900">{selectedProduct.QCStatus}</p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">Stock</label>
                      <p className="mt-1 text-sm text-gray-900">{selectedProduct.BusinessUnits.BusinessUnit.Stock}</p>
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700">Precio</label>
                      <p className="mt-1 text-sm text-gray-900">
                        ${parseFloat(selectedProduct.BusinessUnits.BusinessUnit.Price).toLocaleString('es-CO')}
                      </p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">Precio Especial</label>
                      <p className="mt-1 text-sm text-gray-900">
                        ${parseFloat(selectedProduct.BusinessUnits.BusinessUnit.SpecialPrice).toLocaleString('es-CO')}
                      </p>
                    </div>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Marca</label>
                    <p className="mt-1 text-sm text-gray-900">{selectedProduct.Brand}</p>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Categoría</label>
                    <p className="mt-1 text-sm text-gray-900">{selectedProduct.PrimaryCategory}</p>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700">URL del Producto</label>
                    <a 
                      href={selectedProduct.Url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="mt-1 text-sm text-blue-600 hover:text-blue-800 underline"
                    >
                      Ver en Falabella
                    </a>
                  </div>
                </div>
                
                <div className="mt-6 flex justify-end">
                  <button
                    onClick={closeProductModal}
                    className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition-all duration-200"
                  >
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default FalabellaIntegration
